var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-x-reverse-transition',{attrs:{"hide-on-leave":""}},[_c('div',{key:_vm.refresh,staticClass:"lyrics",domProps:{"textContent":_vm._s(_vm.lyrics)}})])}
var staticRenderFns = []

export { render, staticRenderFns }